// 截取时间当前年月  日期格式如下  2000-01-01 00:00:00
function getCurrentYear(time) {
  if (time) {
    let str = time.split('-')[0]
    let str1 = time.split('-')[1]
    return str + '.' + str1
  }
  return time
}
//截取时间当前日期  日期格式如下  2000-01-01 00:00:00
function getCurrentDate(time) {
  if (time) {
    let str = time.split(' ')[0]
    let str1 = str.split('-')[2]
    return str1
  }
  return time
}

// 时间格式转换 60秒转化为00:01:00

function formatSeconds(seconds) {

  let h = Math.floor(seconds / 3600)
  let m = Math.floor((seconds - h * 3600) / 60)
  let s = seconds - h * 3600 - m * 60
  console.log(h);
  console.log(m);
  if (h > 0) {
    return h + 'h'
  }
  if (m > 0) {
    return m + 'm'
  }
  if (s > 0) {
    return s + 's'
  }
}

export default {
  formatSeconds,
  getCurrentYear,
  getCurrentDate,
}